import useRedirectDecider from "../hooks/useRedirectDecider"

const RouteContainer  = () => {
  useRedirectDecider()

  return ''
}

export default RouteContainer